"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = loadAPCUtil;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

require("regenerator-runtime/runtime");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.match");

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _uigCurrentEnvironmentUtil = require("@sfly/uig-current-environment-util");

var _uigCdnLibraries = require("@sfly/uig-cdn-libraries");

var env = (0, _uigCurrentEnvironmentUtil.getCurrentEnv)();
var documentMode = !!document.documentMode,
    documentModeURL = documentMode ? '/IE' : '';
var version = getCookie('apcstatic-versionUUID');
var sourceURL = env === 'production' ? typeof version === 'undefined' ? "https://cdn.staticsfly.com/apcstatic/dist/APCContainer.bundle.js" : "https://cdn.staticsfly.com/apcstatic/builds/".concat(version, "/dist/APCContainer.bundle.js") : typeof version === 'undefined' ? "https://cdn-".concat(env, ".staticsfly.com/apcstatic/dist/APCContainer.bundle.js") : "https://cdn-".concat(env, ".staticsfly.com/apcstatic/builds/").concat(version, "/dist/APCContainer.bundle.js");
/**
 * if this can not work, check
 * https://gh.internal.shutterfly.com/shutterfly/sfly-sso-client/blob/master/README-INTEGRATIONS.md
 * and update it.
 */

function initSflyAuth() {
  return _initSflyAuth.apply(this, arguments);
}

function _initSflyAuth() {
  _initSflyAuth = (0, _asyncToGenerator2.default)(
  /*#__PURE__*/
  _regenerator.default.mark(function _callee() {
    var initAuth, myAuth, _ref, jwtToken, _ref2, sfly_uid, user, response;

    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;

            if (window.$sflyAuth) {
              _context.next = 7;
              break;
            }

            _context.next = 4;
            return (0, _uigCdnLibraries.loadSflyAuth)();

          case 4:
            initAuth = _context.sent;
            _context.next = 7;
            return initAuth();

          case 7:
            myAuth = window.$sflyAuth;
            _context.next = 10;
            return myAuth.getIdToken();

          case 10:
            _ref = _context.sent;
            jwtToken = _ref.jwtToken;

            if (!(jwtToken !== undefined)) {
              _context.next = 16;
              break;
            }

            /* eslint-disable-next-line */
            _ref2 = myAuth && myAuth.currentUser, sfly_uid = _ref2.sfly_uid;
            user = {
              jwtToken: jwtToken,
              userId: sfly_uid
            };
            return _context.abrupt("return", user);

          case 16:
            _context.next = 21;
            break;

          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", _promise.default.reject(_context.t0));

          case 21:
            response = {
              error: 'something went wrong while fetching user Tokens'
            };
            return _context.abrupt("return", response);

          case 23:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 18]]);
  }));
  return _initSflyAuth.apply(this, arguments);
}

function loadAPCUtil(containerElem, containerId, monitorSource) {
  var closeOnFailure = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  initSflyAuth().then(function (idToken) {
    var script = document.createElement('script');

    script.onload = function () {
      var e = new window.APCContainer({
        containerElem: containerElem,
        userId: idToken.userId,
        env: env === 'production' ? 'prod' : env,
        token: idToken.jwtToken,
        containerId: containerId,
        input: {
          photos: [],
          products: [],
          staticData: {
            header: {
              title: 'MADE JUST FOR YOU',
              promo1: '',
              promo2: ''
            }
          }
        },
        config: {
          monitorSource: monitorSource,
          closeOnFailure: closeOnFailure
        }
      });
      e.renderWidget();
    };

    script.src = sourceURL;
    document.head.appendChild(script);
  });
}

function getCookie(name) {
  var o = document.cookie.match(new RegExp("(^| )".concat(name, "=([^;]+)")));
  return o ? o[2] : undefined;
}

//# sourceMappingURL=index.js.map